/* eslint-disable @typescript-eslint/ban-ts-ignore */
import React from 'react'
import styles from '@bt-react/styles'
import { Col as ReactstrapCol, ColProps as ReactstrapColProps } from 'reactstrap'

interface ColProps extends Partial<ReactstrapColProps> {
  children?: any
}

export default class Col extends React.Component<ColProps> {

  render () {

    return (
      // @ts-ignore
      <ReactstrapCol {...this.props} cssModule={styles} >
        {this.props.children}
      </ReactstrapCol>
    )

  }

}
